import { IReportCatalogSummaryProps } from '../pages/catalog/ReportCatalogSummary';
import {
  IConnectionProps,
  IEmbedReportFilterProps,
  IEmbedReportPageProps,
  IEmbedReportProps,
  IEmbedTagProps,
  IMarketProps,
  IRequestAccessPageProps,
  ISectionProps,
} from './GraphQLTypes';
export type EntityTypeProps =
  | IEmbedReportFilterProps
  | IEmbedReportPageProps
  | IRequestAccessPageProps
  | IEmbedReportProps
  | IMarketProps
  | ISectionProps
  | IEmbedTagProps
  | IConnectionProps
  | IReportCatalogSummaryProps;

export enum EntityType {
  EmbedReportFilter,
  EmbedReportPage,
  Mam,
  AccessRequest,
  EmbedReport,
  Knowledge,
  Market,
  Section,
  EmbedTag,
  ReportCatalogSummary,
  SecurityGroup,
  Connection,
}
